import React, { useState, useEffect } from 'react';
import { getPushStatus, enablePush } from '../utils/pushStatus';

const KEY = 'pushNudgeDismissedAt';
const SNOOZE_MS = 7 * 24 * 3600 * 1000;

/**
 * Players who can't receive push get a small dismissible prompt:
 *  - iPhone in a Safari tab -> opens Settings, which holds the Home Screen walkthrough
 *  - permission not asked yet -> one tap to allow (needs a user gesture)
 * Hidden when push is on, blocked (Settings explains that), or unsupported.
 */
export default function PushNudge({ onOpenSettings }) {
  const [status, setStatus] = useState(null);
  const [hidden, setHidden] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let snoozed = false;
    try { snoozed = Date.now() - Number(localStorage.getItem(KEY) || 0) < SNOOZE_MS; } catch (e) { /* ignore */ }
    if (snoozed) return;
    getPushStatus().then(s => {
      setStatus(s);
      setHidden(!['needs-install', 'default'].includes(s.state));
    });
  }, []);

  if (hidden || !status) return null;

  const dismiss = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* ignore */ }
    setHidden(true);
  };

  const enable = async () => {
    setBusy(true);
    try { await enablePush(); } catch (e) { /* Settings shows the state */ }
    setBusy(false);
    setHidden(true);
  };

  const install = status.state === 'needs-install';
  return (
    <div role="region" aria-label="Notifications"
      style={{ position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 9000, display: 'flex', gap: 10, alignItems: 'center',
        padding: '12px 14px', borderRadius: 14, background: 'linear-gradient(135deg,#2f4ba2,#14246b)', color: '#fff',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)', fontSize: 13 }}>
      <span style={{ flex: 1, lineHeight: 1.35 }}>
        🔔 <strong>{install ? 'Get lesson & slot alerts' : 'Turn on notifications'}</strong><br />
        {install ? 'On iPhone, add CoachPad to your Home Screen first.' : 'Never miss a reply or an open coaching slot.'}
      </span>
      <button type="button" onClick={install ? () => { dismiss(); onOpenSettings && onOpenSettings(); } : enable} disabled={busy}
        style={{ border: 'none', borderRadius: 999, padding: '8px 14px', fontWeight: 700, background: '#fff', color: '#4c3a9e', cursor: 'pointer' }}>
        {install ? 'Show me how' : busy ? '…' : 'Allow'}
      </button>
      <button type="button" onClick={dismiss} aria-label="Dismiss"
        style={{ border: 'none', background: 'transparent', color: '#fff', fontSize: 18, cursor: 'pointer' }}>✕</button>
    </div>
  );
}
